import {Flexbox} from 'src/components/flexbox/Flexbox'
import styled, {css} from 'styled-components'

export const StyledAdminHostApprovalTaskHeroWrapper = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 8}px 0;
    `
)
